var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { partition, orderBy, isArray, isNumber, get, fromPairs } from 'lodash';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FeatureFlagNames, CS_EVOLVE_PRODUCT_TYPE_KEY } from 'constants/app.constant';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { pluralizeUnit } from 'helpers/ui.helper';
import { ASSIGNMENT_TYPES, NAClassname, NEW_CW_DASHBOARD_ASSIGNMENT_SORT_OPTIONS, REPORT_DEPENDENT_OPTIONS, VALUE_NA, VALUE_NA_TEXT, DATE_FORMATS, ASSIGNMENT_TYPE_GROUPS } from '../constants/report.constant';
import { ASSIGNMENT_GRADE_TYPES, PerformancePath } from '../constants/cw.constant';
import AssignmentTypeIcon from '../components/common/assignment-type-icon/AssignmentTypeIcon';
import { isEAQStandalone } from '../services/courses.service';
require('assets/common/images/confirmation-outline-circle.svg');
require('assets/common/images/failed-outline-circle.svg');
export var renderNACell = function (row, column) {
    var cellValue = row[column.field];
    return <div className={cellValue === VALUE_NA ? NAClassname : ''}>{cellValue}</div>;
};
export var renderAvgScoreCell = function (row, column) {
    var cellValue = row[column.field];
    return <div className={cellValue === VALUE_NA ? NAClassname : ''}>{cellValue}</div>;
};
export var renderNameCell = function (row) { return (<div className="u-els-ellipsis" title={row.name}>
    <Link to={"/assignmentDetail/".concat(row.id)}>{row.name}</Link>
  </div>); };
export var renderType = function (row) { return (<div>
    <FormattedMessage id={row.type}/>
  </div>); };
export var renderDueDate = function (row) { return <div title={row.dueDateTimestampFormat}>{row.dueDate}</div>; };
export var renderPastDueCell = function (row) { return <div className={row.countOfPastDue > 0 ? 'u-els-font-family-bold u-els-color-warn' : ''}>{row.countOfPastDue}</div>; };
export var renderAvgCorrectAnswers = function (row) { return <div>{row.avgCorrectAnswers > 0 ? row.avgCorrectAnswers : VALUE_NA}</div>; };
export var renderAvgIncorrectAnswers = function (row) { return <div>{row.avgIncorrectAnswers > 0 ? row.avgIncorrectAnswers : VALUE_NA}</div>; };
export var renderPercentCompleted = function (row) { return <div>{"".concat(row.completedPercent, "%")}</div>; };
export var renderPassScore = function (customClassName) {
    var _a;
    return (<div className="c-cw-pass-fail-score">
      <svg className="c-cw-pass-fail-score__image">
        <use xlinkHref="#confirmation-outline-circle"/>
      </svg>
      <strong className={classNames('u-els-color-confirm u-els-margin-left-1o2 c-cw-pass-fail-score__label', (_a = {}, _a[customClassName] = customClassName, _a))}>Pass</strong>
    </div>);
};
export var renderFailScore = function (customClassName) {
    var _a;
    return (<div className="c-cw-pass-fail-score">
      <svg className="c-cw-pass-fail-score__image">
        <use xlinkHref="#failed-outline-circle"/>
      </svg>
      <strong className={classNames('u-els-color-warn u-els-margin-left-1o2 c-cw-pass-fail-score__label', (_a = {}, _a[customClassName] = customClassName, _a))}>Fail</strong>
    </div>);
};
export var checkShowAssignmentDetail = function (row) {
    return row.countOfInProgress > 0 || row.countOfCompleted > 0 || row.countOfPastDue > 0;
};
export var formatTimeSpentToMinutes = function (row) {
    var min = moment.duration(row.timeSpent).asMinutes();
    return min >= 1 ? "".concat(Math.ceil(min), " min") : '-';
};
export var formatTimeSpentToMinutesAndSeconds = function (row) {
    if (!(row === null || row === void 0 ? void 0 : row.timeSpent))
        return '-';
    var totalSeconds = Math.floor(moment.duration(row.timeSpent).asSeconds());
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    if (minutes === 0 && seconds === 0)
        return '-';
    if (minutes === 0)
        return "".concat(seconds).concat(pluralizeUnit(seconds, 'sec'));
    if (seconds === 0)
        return "".concat(minutes).concat(pluralizeUnit(minutes, 'min'));
    return "".concat(minutes).concat(pluralizeUnit(minutes, 'min'), " ").concat(seconds).concat(pluralizeUnit(seconds, 'sec'));
};
export var convertQuizTypeToType = function (quizType) {
    return ASSIGNMENT_TYPES[quizType];
};
export var renderAssignmentType = function (assignmentTypeField) { return function (row) {
    var assignmentType = get(row, assignmentTypeField, row.assignmentType || row.id);
    return (<span>
      <AssignmentTypeIcon type={assignmentType}/>
    </span>);
}; };
export var getHiddenDependentOption = function (excludeOptions, assignmentTypeMenuOptions) {
    var hideOptions = [];
    excludeOptions.forEach(function (excludeOption) {
        var dependentOption = REPORT_DEPENDENT_OPTIONS === null || REPORT_DEPENDENT_OPTIONS === void 0 ? void 0 : REPORT_DEPENDENT_OPTIONS.find(function (option) { return option.dependentOptionlist.includes(excludeOption); });
        var hasParentDependentOption = assignmentTypeMenuOptions.findIndex(function (option) { return option.key === (dependentOption === null || dependentOption === void 0 ? void 0 : dependentOption.parentOption); }) > -1;
        if (hasParentDependentOption) {
            hideOptions = __spreadArray(__spreadArray([], hideOptions, true), [excludeOption], false);
        }
    });
    return hideOptions;
};
export var roundAccurately = function (value, decimalPlaces) {
    var multipliedValue = "".concat(value, "e").concat(decimalPlaces);
    return Number("".concat(Math.round(Number(multipliedValue)), "e-").concat(decimalPlaces));
};
export var renderPercentValue = function (val, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 0; }
    var value = val > 1 ? val : val * 100;
    return "".concat(roundAccurately(value, decimalPlaces), "%");
};
export var renderAvgScorePercent = function (assignmentGradeType, avgScore) {
    var avgScoreValue;
    var percentValue = renderPercentValue(avgScore);
    switch (assignmentGradeType) {
        case ASSIGNMENT_GRADE_TYPES.NOT_GRADED.key:
            return ASSIGNMENT_GRADE_TYPES.NOT_GRADED.label;
        case ASSIGNMENT_GRADE_TYPES.PASS_FAIL.key:
            avgScoreValue = "".concat(percentValue, " Passed");
            break;
        case ASSIGNMENT_GRADE_TYPES.SCORED.key:
            avgScoreValue = percentValue;
            break;
        default:
            break;
    }
    return isNumber(avgScore) ? avgScoreValue : VALUE_NA_TEXT;
};
export var renderWeightedGradePoints = function (_a) {
    var assignmentGradeType = _a.assignmentGradeType, points = _a.points, totalPoints = _a.totalPoints, featureFlags = _a.featureFlags, pastDue = _a.pastDue, _b = _a.courseId, courseId = _b === void 0 ? '' : _b, _c = _a.withParenthesis, withParenthesis = _c === void 0 ? true : _c;
    var isGradePointEnable = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_GRADE_WEIGHTING_SCORE_ENABLED, courseId);
    var weightedGradePoints = "".concat(!pastDue ? Math.round(points * totalPoints * 100 + Number.EPSILON) / 100 : 0, "/").concat(Math.round(totalPoints) || 0, " points");
    if (assignmentGradeType !== ASSIGNMENT_GRADE_TYPES.NOT_GRADED.key && isGradePointEnable) {
        return "".concat(withParenthesis ? '(' : '').concat(weightedGradePoints).concat(withParenthesis ? ')' : '');
    }
    return '';
};
export var renderWeightedGradePointsInGradebook = function (_a) {
    var assignmentGradeType = _a.assignmentGradeType, points = _a.points, totalPoints = _a.totalPoints, featureFlags = _a.featureFlags, _b = _a.courseId, courseId = _b === void 0 ? '' : _b, _c = _a.withParenthesis, withParenthesis = _c === void 0 ? true : _c;
    var isGradePointEnable = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_GRADE_WEIGHTING_SCORE_ENABLED_IN_GRADEBOOK, courseId);
    var numOfPoints = Math.round(points * totalPoints * 100 + Number.EPSILON) / 100;
    var weightedGradePoints = "".concat(!isNaN(numOfPoints) ? numOfPoints : 0, "/").concat(Math.round(totalPoints) || 0, " points");
    if (assignmentGradeType !== ASSIGNMENT_GRADE_TYPES.NOT_GRADED.key && isGradePointEnable) {
        return "".concat(withParenthesis ? '(' : '').concat(weightedGradePoints).concat(withParenthesis ? ')' : '');
    }
    return '';
};
export var getPointFromWeightedGradePoints = function (gradePoints) {
    var gradePointsValue = gradePoints.split('/', 2);
    var regex = new RegExp('([0-9]*[.])?[0-9]+', 'g');
    var point = +gradePointsValue[0].match(regex)[0];
    var gradePoint = +gradePointsValue[1].match(regex)[0];
    return { point: point, gradePoint: gradePoint };
};
export var sortSummaryAssignments = function (assignments, sortDirection, sortOption) {
    var direction = sortDirection === 'asc' ? 1 : -1;
    switch (sortOption) {
        case NEW_CW_DASHBOARD_ASSIGNMENT_SORT_OPTIONS[0].value: {
            // sort by due date
            return __spreadArray([], assignments, true).sort(function (a, b) { return direction * moment(a.dueDate).diff(moment(b.dueDate)); });
        }
        case NEW_CW_DASHBOARD_ASSIGNMENT_SORT_OPTIONS[2].value: {
            // sort by class avg score
            var _a = partition(assignments, ['assignmentGradeType', 'NOT_GRADED']), notGradedAssignments = _a[0], gradedAssignments = _a[1];
            var sortedNotGradedAssignments = __spreadArray([], notGradedAssignments, true).sort(function (a, b) { return (a.assignmentName > b.assignmentName ? 1 : -1); });
            var sortedGradeAssignments = __spreadArray([], gradedAssignments, true).sort(function (a, b) {
                if (a.avgScore === b.avgScore) {
                    return a.assignmentName > b.assignmentName ? 1 : -1;
                }
                return direction * (a[sortOption] - b[sortOption]);
            });
            return direction > 0 ? __spreadArray(__spreadArray([], sortedNotGradedAssignments, true), sortedGradeAssignments, true) : __spreadArray(__spreadArray([], sortedGradeAssignments, true), sortedNotGradedAssignments, true);
        }
        case NEW_CW_DASHBOARD_ASSIGNMENT_SORT_OPTIONS[3].value: {
            // sort by average time spent
            return __spreadArray([], assignments, true).sort(function (a, b) { return direction * (moment.duration(a[sortOption]).asSeconds() - moment.duration(b[sortOption]).asSeconds()); });
        }
        default: {
            return __spreadArray([], assignments, true).sort(function (a, b) { return direction * (a[sortOption] - b[sortOption]); });
        }
    }
};
export var renderColumn = function (column, defaultHandleHeaderClick) {
    var field = column.field, header = column.header, sticky = column.sticky, align = column.align, customRender = column.customRender, customSort = column.customSort, handleHeaderClick = column.handleHeaderClick;
    var columnProps = {
        field: field,
        header: header,
        sticky: sticky,
        sortable: true,
        align: align,
        customSort: customSort,
        customRender: customRender,
        handleHeaderClick: handleHeaderClick || defaultHandleHeaderClick
    };
    return <column key={field} {...columnProps}/>;
};
export var getValidAssignments = function (assignments) {
    var field = 'assignmentType';
    return assignments.filter(function (asm) { return ASSIGNMENT_TYPES[asm[field]]; });
};
export var getSortedCourseAggregate = function (courseAggregateData, direction, value) {
    return orderBy(courseAggregateData, value, direction);
};
export var isNotGradeAssignment = function (gradeType) {
    return gradeType === ASSIGNMENT_GRADE_TYPES.NOT_GRADED.key;
};
export var isEABAssignment = function (assignmentType) {
    var assignmentEABTypeId = ASSIGNMENT_TYPES.PERSONAL_ASSESSMENT_BUILDER.id;
    if (isArray(assignmentType)) {
        return assignmentType.includes(assignmentEABTypeId);
    }
    return assignmentType === assignmentEABTypeId;
};
export var isEAQAssignment = function (assignmentType) {
    var types = isArray(assignmentType) ? assignmentType : [assignmentType];
    return types.length > 0 && types.every(function (type) { var _a; return ((_a = ASSIGNMENT_TYPES[type]) === null || _a === void 0 ? void 0 : _a.group) === ASSIGNMENT_TYPE_GROUPS.EAQ; });
};
export var getIsOsmosisAssignment = function (assignmentType) {
    var osmosisTypeId = ASSIGNMENT_TYPES.OSMOSIS_VIDEO.id;
    if (isArray(assignmentType)) {
        return assignmentType.every(function (at) { return at === osmosisTypeId; });
    }
    return assignmentType === osmosisTypeId;
};
export var getEngagementLandingPath = function (courseSectionInfo) {
    return isEAQStandalone(courseSectionInfo) ? PerformancePath.engagement.assignment : PerformancePath.engagementSummary;
};
export var remapCourseAggregate = function (courseAggregate, courseSection) {
    var activeCourseWithRecentActivity = courseSection.activeCourseWithRecentActivity, createdAt = courseSection.createdAt, updatedAt = courseSection.updatedAt, courseName = courseSection.courseName, _a = courseSection.entitlements, entitlements = _a === void 0 ? [] : _a;
    var courseCreationDate = updatedAt || createdAt;
    var isCSCourse = entitlements.some(function (_a) {
        var evolveProductTypeKey = _a.evolveProductTypeKey;
        return evolveProductTypeKey === CS_EVOLVE_PRODUCT_TYPE_KEY;
    });
    if (isNumber(courseCreationDate)) {
        courseCreationDate = moment(courseCreationDate).format(DATE_FORMATS.CUSTOM);
    }
    return __assign(__assign({}, courseAggregate), { courseActive: activeCourseWithRecentActivity, courseCreationDate: courseCreationDate, courseName: courseName, isCSCourse: isCSCourse });
};
export var remapCourseSection = function (courseSection) {
    var activeCourseWithRecentActivity = courseSection.activeCourseWithRecentActivity, createdAt = courseSection.createdAt, updatedAt = courseSection.updatedAt, courseName = courseSection.courseName;
    var courseCreationDate = updatedAt || createdAt;
    if (isNumber(courseCreationDate)) {
        courseCreationDate = moment(courseCreationDate).format(DATE_FORMATS.CUSTOM);
    }
    return __assign(__assign({}, courseSection), { courseActive: activeCourseWithRecentActivity, courseCreationDate: courseCreationDate, courseName: courseName });
};
export var naNtoZero = function (value) {
    if (typeof value === 'string') {
        return isNaN(parseFloat(value)) ? 0 : parseFloat(value);
    }
    return isNaN(value) ? 0 : value;
};
export var filterByRange = function (assignmentMetrics, startOffset, endOffset) {
    var today = moment().startOf('day');
    return assignmentMetrics.filter(function (assignment) {
        return (assignment === null || assignment === void 0 ? void 0 : assignment.dueDate) && moment(assignment.dueDate).isBetween(today.clone().add(startOffset, 'days'), today.clone().add(endOffset, 'days'));
    });
};
export var isValidAssignmentTypes = function (assignmentTypes, types) {
    var typeMaps = fromPairs((types || []).map(function (type) { return [type, true]; }));
    return (assignmentTypes || []).every(function (type) { return !!typeMaps[type]; });
};
